import { BoilerAdapter, BoilerCascade, HeatingCircuit, } from 'z3k-config';
import { idExtractor } from 'z3k-parser/lib/id';
export function getHeatingCircuitByType(config, type) {
    return HeatingCircuit.get.where(config, (hc) => hc.type === type);
}
export function isCircuitWithBoilerAdapter(config, hc) {
    if (config == null) {
        return false;
    }
    //берём все адаптеры
    const boiler_adapters_ids = idExtractor([
        BoilerAdapter,
    ])(config);
    return HeatingCircuit.isCircuitWithBoilerAdapter(boiler_adapters_ids, hc);
}
export function HeatingCircuitInBoilerCascade(hc, z3k_config) {
    const boiler_cascades = BoilerCascade.get.all(z3k_config);
    const boiler_circuit = HeatingCircuit.get.one(z3k_config, (boiler) => boiler.id === hc.id);
    const circuit_cascade = boiler_cascades.find((cascade) => cascade.boiler_list.includes(hc.id));
    if (circuit_cascade) {
        if (BoilerCascade.isOff(circuit_cascade)) {
            return {
                cascade_index: undefined,
                boiler_position: undefined,
                title: undefined,
            };
        }
        const cascade_index = boiler_cascades.findIndex((cascade) => cascade.id === circuit_cascade?.id) +
            1;
        return {
            cascade_index,
            boiler_position: boiler_circuit?.position,
            title: circuit_cascade?.name,
        };
    }
    return { cascade_index: undefined, boiler_position: undefined, title: undefined };
}
